import styled, { css } from 'styled-components'
import { Button } from '@sainsburys-tech/bolt'
import { createCSSObject } from '../../../helpers/theming/utilities'
import { BackgroundImage, marginBottomCSS } from '../../../helpers/StyledWrappers.styles'

const xSpacing = (props, size) => props.theme.size.spacing[size]

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  height: 100%;
  padding-bottom: ${(props) => xSpacing(props, 'lg')};
  cursor: ${(props) => props.onClick !== undefined && 'pointer'};
  background-color: ${(props) =>
    props.theme.color.monochrome[
      props.theme.channel === 'nectar' || props.theme.channel === 'sainsburys' ? 'white' : 'lighter'
    ]};

  ${(props) =>
    props.theme.channel === 'sainsburys' &&
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) and (max-width: ${props.theme.size
          .breakpoint['max-width'].md}) {
        display: flex;
        flex-direction: row;
        padding-bottom: 0;
      }
    `}

  //TODO: Remove this css once nav team add their changes for m053 new props
  ${(props) =>
    props.theme.channel === 'argos' &&
    css`
      :hover {
        text-decoration: underline;
      }
    `}
`

const TextAndCTAWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  ${(props) =>
    props.theme.channel === 'sainsburys' &&
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) and (max-width: ${props.theme.size
          .breakpoint['max-width'].md}) {
        width: 50%;
        justify-content: center;
        margin-left: ${xSpacing(props, 'lg')};
      }
    `}
`

const TextWrapper = styled.div`
  ${(props) =>
    css`
      margin: ${xSpacing(props, 'md')} ${xSpacing(props, 'lg')} 0 ${xSpacing(props, 'lg')};
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        margin: ${xSpacing(props, 'lg')} ${xSpacing(props, 'xl')} 0 ${xSpacing(props, 'xl')};
      }
    `}
`

const Heading = styled.h4`
  && {
    ${marginBottomCSS}
  }

  ${(props) =>
    props.isOffer &&
    css`
      color: ${props.theme.color.content.sale};
    `};
`

const ImageWrapper = styled.div`
  position: relative;
  ${(props) =>
    props.backgroundColor &&
    css`
      background-color: ${props.backgroundColor};
    `}
  &::before {
    content: '';
    display: block;
    ${(props) =>
      props.theme.channel !== 'sainsburys' &&
      css`
        padding-bottom: 100%;
      `}
  }
  ${(props) =>
    props.theme.channel === 'sainsburys' &&
    css`
      padding-top: clamp(268px, 70%, 329px);
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) and (max-width: ${props.theme.size
          .breakpoint['max-width'].md}) {
        padding-top: 0;
      }
    `}

  img {
    ${BackgroundImage}
    max-width: 100%;
  }

  ${(props) =>
    props.theme.channel === 'sainsburys' &&
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) and (max-width: ${props.theme.size
          .breakpoint['max-width'].md}) {
        width: 100%;
        max-width: 50%;

        &::before {
          padding-bottom: 0;
        }
        img {
          position: static;
          top: 0;
          left: 0;
          object-fit: cover;
        }
      }
    `}
`

const CTAButton = styled(Button)`
  ${marginBottomCSS}
  ${(props) =>
    css`
      @media screen and (max-width: ${props.theme.size.breakpoint['max-width'].xs}) {
        width: 100%;
      }
    `}

    ${(props) =>
    !props.isLinkCta &&
    css`
      min-width: 112px;
    `}
`

const BodyCopy = styled.p`
  && {
    ${marginBottomCSS}
  }
`

const LegalCopy = styled.div`
  && {
    ${marginBottomCSS}
    ${(props) => createCSSObject(props.theme.font.stack.caption)}
    margin-top: ${(props) =>
      props.theme.channel === 'sainsburys' ? props.theme.size.spacing.lg : props.theme.size.spacing.md};
  }
`

const CTAAndLegalCopyContainer = styled.div`
  margin-top: auto;
  ${(props) =>
    css`
      margin: auto ${xSpacing(props, 'lg')} 0 ${xSpacing(props, 'lg')};
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        margin: auto ${xSpacing(props, 'md')} 0 ${xSpacing(props, 'xl')};
      }
    `}
  ${(props) =>
    props.theme.channel === 'sainsburys' &&
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) and (max-width: ${props.theme.size
          .breakpoint['max-width'].md}) {
        margin-top: 0;
      }
    `}
    ${(props) =>
    css`
      @media screen and (max-width: ${props.theme.size.breakpoint['max-width'].sm}) {
        display: flex;
        flex-direction: column;
      }
    `}
`
const CTAContainer = styled.div`
  display: inline-block;
  > * {
    &:first-child {
      margin-right: ${(props) =>
        props.theme.channel === 'sainsburys' ? xSpacing(props, 'lg') : xSpacing(props, 'md')};
    }
  }
`

export {
  Container,
  TextAndCTAWrapper,
  ImageWrapper,
  TextWrapper,
  Heading,
  CTAButton,
  BodyCopy,
  LegalCopy,
  CTAAndLegalCopyContainer,
  CTAContainer
}
